import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchUserText } from "../../../store/formsubmitted";

import { RootState } from "../../../store/rootReducer";


export const UserSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((state: RootState) => state.formSubmittedSlice.searchUserText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchUserText(value));
            }}
            debounce={700}
            placeholder={"Buscar Usuarios..."}
            autocomplete="off"
        />
    );
};
